<template>
    <div class="allbox">
        <div class="cases_box">
           <h4>案例</h4>
           <div class="cases_bigbox rows">
             <div class="caseitem_wrap" v-for="item in caselists" :key="item.title">
            <router-link :to="item.id">
                 <div class="caseimg_wrap">
               <img :src="item.img" alt="">  
                 </div>          
            </router-link>
           

             <h6>{{item.title}}</h6>
             <p>{{item.word}}</p>
           </div>

           </div>       
        </div>
        <foot></foot>
    </div>
</template>
<style>
.cases_box {
  height: 8.96rem;
  background: rgba(245, 245, 245, 1);
}
.cases_box h4 {
  text-align: center;
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
}
.cases_bigbox {
  width: 12rem;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-between;
}
.caseitem_wrap {
  width: 3.86rem;
  height: 3.4rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0.05rem 0.11rem 0 rgba(223, 224, 233, 1);
  margin-bottom: 0.2rem;
}
.caseitem_wrap .caseimg_wrap {
  width: 100%;
  height: 2.1rem;
  cursor: pointer;
}
.cases_box h6 {
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding: 0.2rem;
  cursor: pointer;
}
.cases_box p {
  width: 3.36rem;
  font-size: 0.12rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.2rem;
  cursor: pointer;
}
.cases_box h6:hover,
.cases_box p:hover {
  color: #409eff;
}
</style>
<script>
import footer from "../common/footer";
export default {
  data() {
    return {
      caselists: [
        {
          id:"/subulei",
          img: require("../assets/cases/ditie.png"),
          title: "苏布雷水电站GNSS监测系统",
          word:
            "苏布雷水电站GNSS监测系统是一套以数据采集、数据通讯为基 础，自动进行数据分析、成果报告生成等全流程监测系统 "
        },
        {
          id:"/chongqing",
          img: require("../assets/cases/daba.png"),
          title: "山城重庆三号线轻轨碧津站附近某学校",
          word:
            "保证三号线轻轨安全运营和周边楼房的安全，对该基坑周围的 轻轨桥梁、学校教学楼、居民楼房进行实时变形监测 "
        },
        {
          id:"/shaoguan",
          img: require("../assets/cases/bianp.png"),
          title: "韶关市危房监测项目",
          word: "运用了岩蚁RocMos自动化变形监测系统对危房进行了实时监测"
        },
        {
          id:"/lianhe",
          img: require("../assets/cases/dizhi.png"),
          title: "地铁自动化监测-多台仪器联测案例",
          word:
            "根据现场实际情况，方案定为4台仪器联测，监测项目包括隧道 水平位移，竖向位移，径向收敛，轨道横向高差，隧道变形相对 曲率 "
        },
        {
          id:"/guangdong",
          img: require("../assets/cases/weik.png"),
          title: "广东省某县危桥监测项目",
          word: "对桥梁结构位移、沉降变化、桥体倾斜进行三维变形监测"
        },
        {
          id:"/tiankeng",
          img: require("../assets/cases/wenwu.png"),
          title: "亚洲第一天坑蝶变4A景区",
          word:
            "使用GNSS自动化实时监测系统，通过RT-2000-GS监测终端内 置4G通讯模组与RocMoS自动化监测软件连接，组成一体化监 测系统"
        }
      ]
    };
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/cases.vue